var _circle, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordpressLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 65,
    fill: "#ADADAD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_247_7)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31073 65.4984C9.31073 87.7396 22.2364 106.96 40.9798 116.069L14.1757 42.6306C11.0578 49.6188 9.31073 57.3522 9.31073 65.4984Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.436 62.6629C103.436 55.7185 100.941 50.9093 98.8017 47.1661C95.9533 42.5376 93.2835 38.618 93.2835 33.9895C93.2835 28.8242 97.2011 24.0161 102.719 24.0161C102.968 24.0161 103.205 24.0471 103.447 24.061C93.4503 14.9023 80.1311 9.31049 65.5021 9.31049C45.8714 9.31049 28.6004 19.3822 18.553 34.6374C19.8713 34.6769 21.1137 34.7047 22.1691 34.7047C28.0465 34.7047 37.1445 33.9916 37.1445 33.9916C40.1735 33.813 40.5307 38.2619 37.5048 38.6201C37.5048 38.6201 34.4607 38.9783 31.0735 39.1558L51.5361 100.019L63.8331 63.1398L55.0784 39.1536C52.0525 38.9761 49.1859 38.618 49.1859 38.618C46.1579 38.4405 46.5129 33.8109 49.5409 33.9895C49.5409 33.9895 58.8206 34.7026 64.342 34.7026C70.2184 34.7026 79.3174 33.9895 79.3174 33.9895C82.3487 33.8109 82.7047 38.2598 79.6778 38.618C79.6778 38.618 76.6273 38.9761 73.2464 39.1536L93.5529 99.5563L99.1578 80.8273C101.587 73.0554 103.436 67.4732 103.436 62.6629Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.488 70.4135L49.6286 119.403C54.6625 120.882 59.9861 121.692 65.5021 121.692C72.0457 121.692 78.3209 120.56 84.162 118.507C84.0113 118.266 83.8744 118.01 83.7622 117.732L66.488 70.4135Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.808 38.5399C115.049 40.3297 115.186 42.2511 115.186 44.3178C115.186 50.0198 114.121 56.4296 110.914 64.4442L93.7497 114.068C110.455 104.327 121.691 86.2289 121.691 65.4995C121.693 55.7303 119.197 46.5439 114.808 38.5399Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5021 0C29.3852 0 0 29.3823 0 65.4984C0 101.619 29.3852 131 65.5021 131C101.618 131 131.007 101.619 131.007 65.4984C131.006 29.3823 101.618 0 65.5021 0ZM65.5021 127.998C31.0414 127.998 3.00342 99.9604 3.00342 65.4984C3.00342 31.0385 31.0403 3.00335 65.5021 3.00335C99.9618 3.00335 127.998 31.0385 127.998 65.4984C127.998 99.9604 99.9618 127.998 65.5021 127.998Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 131,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressLogo);
export default __webpack_public_path__ + "static/media/wordpress-logo.ad0037c1119d5cd1254da1efd6ad49ef.svg";
export { ForwardRef as ReactComponent };